module.exports = __webpack_public_path__ + "img/ic_chevron_left_black_48px.031d76b3.svg";